import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { MedicalItemMedicalReaction } from "@/Patient/Models/MedicalSummary/MedicalItemMedicalReaction";

import styles from "./MedicalReactionContainer.module.scss";

interface IMedicalReactionContainerProps {
    medicalReactions: MedicalItemMedicalReaction[],
    circleName: string;
    circleClassName: string;
    dataCy: string;
    showEmptyLabel?: boolean;
    onMedicalItemClick: (model: MedicalItemMedicalReaction, view: MedicalItemsTab) => void;
}

function MedicalReactionContainer(props: IMedicalReactionContainerProps): JSX.Element {
    const { getText } = useTranslation();

    if (isArrayNullOrUndefinedOrEmpty(props.medicalReactions) && !props.showEmptyLabel) {
        return null;
    }

    return (
        <div className="flex-container flex-align-items-center">
            <div className="medical-reaction c1" style={{ padding: "3px 0", width: "20px" }}>
                <ul className="circles">
                    <li>
                        <span className={props.circleClassName}>
                            <i>{props.circleName}</i>
                        </span>
                    </li>
                </ul>
            </div>
            <div className="medical-reaction c2" data-cy={props.dataCy}>
                {props.medicalReactions?.map((medicalReaction, idx) => {
                    const offendingAgentInUpperCase = medicalReaction.OffendingAgent.toUpperCase();
                    const comma = (idx == props.medicalReactions.length - 1) ? "" : ", ";
                    const invalidStyle = medicalReaction.DisplayAsInvalid ? "invalid-medical-item" : "";

                    return (
                        <a
                            key={medicalReaction.MedicalItemId}
                            className="note-items-list"
                            onClick={() =>
                                props.onMedicalItemClick(medicalReaction, MedicalItemsTab.MedicalReactions)
                            }
                        >
                            <span className={invalidStyle}>{offendingAgentInUpperCase}{comma} </span>
                        </a>
                    );
                })}
                {!props.medicalReactions?.length && (
                    <span className={styles.emptyLabel}>{getText("PharmacyOrders_NothingOnFileLabel")}</span>
                )}
            </div>
        </div>
    );
}

export { MedicalReactionContainer };
